import type { NavigateOptions } from "@tanstack/react-router";

type AppNavigate = (options: NavigateOptions) => void;

export function navigateFromActionUrl(actionUrl: string, nav: AppNavigate) {
  if (actionUrl.startsWith("/app/camp-registrations/waitlist")) {
    const classTypeId = new URL(actionUrl, "http://local").searchParams.get(
      "classTypeId",
    );
    nav({
      to: "/app/camp-registrations/waitlist",
      search: classTypeId ? { classTypeId } : {},
    });
    return;
  }

  const campMatch = actionUrl.match(/^\/app\/camp-registrations\/([^/?#]+)/);
  if (campMatch?.[1] && campMatch[1] !== "waitlist") {
    nav({
      to: "/app/camp-registrations/$id",
      params: { id: campMatch[1] },
    });
    return;
  }

  const jamMatch = actionUrl.match(/^\/app\/jam-registrations\/([^/?#]+)/);
  if (jamMatch?.[1]) {
    nav({
      to: "/app/jam-registrations/$id",
      params: { id: jamMatch[1] },
    });
    return;
  }

  if (actionUrl.startsWith("/app/visitor-lottery/registrations")) {
    const eventId = new URL(actionUrl, "http://local").searchParams.get(
      "eventId",
    );
    nav({
      to: "/app/visitor-lottery/registrations",
      search: eventId ? { eventId } : {},
    });
    return;
  }

  if (actionUrl.startsWith("/app/visitor-lottery")) {
    nav({ to: "/app/visitor-lottery" });
    return;
  }

  if (actionUrl.startsWith("/app/")) {
    nav({ to: actionUrl as "/app/dashboard" });
  }
}
